<template>
  <div>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back toolbar-button" @click="goBack">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.97508 4.94189L2.91675 10.0002L7.97508 15.0586" stroke="black" stroke-width="1.5"
              stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17.0833 10H3.05835" stroke="black" stroke-width="1.5" stroke-miterlimit="10"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>

        </ion-button>
      </ion-buttons>
      <ion-buttons slot="end">
        <ion-button @click="save('userForm')" :disabled="formsData.userForm.disabled" class="pill next-pill-button">
          <span>Save</span>
        </ion-button>
      </ion-buttons>
      <ion-title>My Profile</ion-title>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
      <el-form :model="formsData?.userForm" :rules="formsData?.userForm.rules"
        :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="goNext('userForm')"
        @keyup.enter="goNext('userForm')">
        <div class="settings_menu">
          <div class="menu_title">
            <span>Personal Details</span>
          </div>
        </div>
        <!-- WORKING -->
        <div class="form_part">
          <el-form-item label="First Name" prop="firstName">
            <el-input v-model="formsData.userForm.firstName.value" autocomplete="off" placeholder="First Name"
              :maxlength="20" @input="fixValidation" @keyup="
                formsData.userForm.firstName.value = $event.target.value
                "></el-input>
          </el-form-item>
          <el-form-item label="Last Name" prop="lastName">
            <el-input v-model="formsData.userForm.lastName.value" autocomplete="off" placeholder="Last Name"
              :maxlength="20" @input="fixValidation"
              @keyup="formsData.userForm.lastName.value = $event.target.value"></el-input>
          </el-form-item>
          <el-form-item label="Enter your City and State" prop="address">
            <div class="el-input el-input--prefix">
              <vue-google-suburb-autocomplete id="map" classname="el-input__inner"
                :ref="(el) => (formsData.userForm.address.ref = el)" v-model="formsData.userForm.address.value.text"
                placeholder="Enter your City and State" @placechanged="setAddressData" @input="fixValidation"
                @keyup="setAddress" :country="countryArray">
              </vue-google-suburb-autocomplete>
              <span class="el-input__prefix"><i class="el-input__icon el-icon-search"></i></span>
            </div>
          </el-form-item>
        </div>
        <!-- !!!!!  -->
        <!-- WORKING -->
        <div class="form_part">
          <el-form-item label="Mobile Number" prop="mobileNumber" :required="true"
            class="collapsing-dropdown-scroll-off">
            <div class="el-input">
              <vue-tel-input class="el-input__inner" :value="formsData.userForm.mobileNumber.valueFormatted"
                v-model="formsData.userForm.mobileNumber.value" @input="onPhoneInput"
                :preferredCountries="[$filters.vueTelInput()]" :autoDefaultCountry="false"
                v-bind="{ mode: 'international' }"></vue-tel-input>
            </div>
          </el-form-item>
          <el-form-item label="Email" prop="email" :required="true">
            <el-input type="email" v-model="formsData.userForm.email.value" placeholder="email@gmail.com"
              @input="fixValidation"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="settings_menu">
      <div class="menu_title">
        <el-button type="transparent" class="menu_item" @click="links.changeJobSeekerAdditional">
          <!-- <i class="locumate_icons el-icon-pie-chart"></i> -->
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.75 2.44995C11.45 1.85995 12.58 1.85995 13.26 2.44995L14.84 3.79995C15.14 4.04995 15.71 4.25995 16.11 4.25995H17.81C18.87 4.25995 19.74 5.12995 19.74 6.18995V7.88995C19.74 8.28995 19.95 8.84995 20.2 9.14995L21.55 10.7299C22.14 11.4299 22.14 12.5599 21.55 13.2399L20.2 14.8199C19.95 15.1199 19.74 15.6799 19.74 16.0799V17.7799C19.74 18.8399 18.87 19.7099 17.81 19.7099H16.11C15.71 19.7099 15.15 19.9199 14.85 20.1699L13.27 21.5199C12.57 22.1099 11.44 22.1099 10.76 21.5199L9.18001 20.1699C8.88001 19.9199 8.31 19.7099 7.92 19.7099H6.17C5.11 19.7099 4.24 18.8399 4.24 17.7799V16.0699C4.24 15.6799 4.04 15.1099 3.79 14.8199L2.44 13.2299C1.86 12.5399 1.86 11.4199 2.44 10.7299L3.79 9.13995C4.04 8.83995 4.24 8.27995 4.24 7.88995V6.19995C4.24 5.13995 5.11 4.26995 6.17 4.26995H7.9C8.3 4.26995 8.86 4.05995 9.16 3.80995L10.75 2.44995Z"
              stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M12 8.13V12.96" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11.9945 16H12.0035" stroke="rgb(var(--locumate-primary-color))" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>




          <div class="text_wrapper">
            <div class="main_text">Additional Information</div>
          </div>
        </el-button>
        <el-button type="transparent" class="menu_item" @click="links.softwareExperience">
          <!-- <i class="locumate_icons el-icon-pie-chart"></i> -->
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.89001 9C7.87001 9.49 8.71001 10.23 9.32001 11.15C9.67001 11.67 9.67001 12.34 9.32001 12.86C8.71001 13.77 7.87001 14.51 6.89001 15"
              stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M13 15H17" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
              stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>



          <div class="text_wrapper">
            <div class="main_text">Software Experience</div>
          </div>
        </el-button>
        <el-button type="transparent" class="menu_item" @click="links.pharmacyExperience">
          <!-- <i class="locumate_icons el-icon-pie-chart"></i> -->
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 9C19 10.45 18.57 11.78 17.83 12.89C16.75 14.49 15.04 15.62 13.05 15.91C12.71 15.97 12.36 16 12 16C11.64 16 11.29 15.97 10.95 15.91C8.96 15.62 7.25 14.49 6.17 12.89C5.43 11.78 5 10.45 5 9C5 5.13 8.13 2 12 2C15.87 2 19 5.13 19 9Z"
              stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M21.25 18.47L19.6 18.86C19.23 18.95 18.94 19.23 18.86 19.6L18.51 21.07C18.32 21.87 17.3 22.11 16.77 21.48L12 16L7.22996 21.49C6.69996 22.12 5.67996 21.88 5.48996 21.08L5.13996 19.61C5.04996 19.24 4.75996 18.95 4.39996 18.87L2.74996 18.48C1.98996 18.3 1.71996 17.35 2.26996 16.8L6.16996 12.9C7.24996 14.5 8.95996 15.63 10.95 15.92C11.29 15.98 11.64 16.01 12 16.01C12.36 16.01 12.71 15.98 13.05 15.92C15.04 15.63 16.75 14.5 17.83 12.9L21.73 16.8C22.28 17.34 22.01 18.29 21.25 18.47Z"
              stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M12.58 5.98L13.17 7.15999C13.25 7.31999 13.46 7.48 13.65 7.51L14.72 7.68999C15.4 7.79999 15.56 8.3 15.07 8.79L14.24 9.61998C14.1 9.75998 14.02 10.03 14.07 10.23L14.31 11.26C14.5 12.07 14.07 12.39 13.35 11.96L12.35 11.37C12.17 11.26 11.87 11.26 11.69 11.37L10.69 11.96C9.96997 12.38 9.53997 12.07 9.72997 11.26L9.96997 10.23C10.01 10.04 9.93997 9.75998 9.79997 9.61998L8.96997 8.79C8.47997 8.3 8.63997 7.80999 9.31997 7.68999L10.39 7.51C10.57 7.48 10.78 7.31999 10.86 7.15999L11.45 5.98C11.74 5.34 12.26 5.34 12.58 5.98Z"
              stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>



          <div class="text_wrapper">
            <div class="main_text">Advanced Credentials</div>
          </div>
        </el-button>
        <el-button type="transparent" class="menu_item" @click="links.universities" v-if="userData.platformRoleSlug == 'intern-pharmacist' && isAustralia">
          <!-- <i class="locumate_icons el-icon-pie-chart"></i> -->
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.05 2.53004L4.03002 6.46004C2.10002 7.72004 2.10002 10.54 4.03002 11.8L10.05 15.73C11.13 16.44 12.91 16.44 13.99 15.73L19.98 11.8C21.9 10.54 21.9 7.73004 19.98 6.47004L13.99 2.54004C12.91 1.82004 11.13 1.82004 10.05 2.53004Z"
              stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              d="M5.63 13.08L5.62 17.77C5.62 19.04 6.6 20.4 7.8 20.8L10.99 21.86C11.54 22.04 12.45 22.04 13.01 21.86L16.2 20.8C17.4 20.4 18.38 19.04 18.38 17.77V13.13"
              stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M21.4 15V9" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>




          <div class="text_wrapper">
            <div class="main_text">Universities</div>
          </div>
        </el-button>
        <el-button type="transparent" class="menu_item" @click="links.registration" v-if="userData.platformRoleSlug == 'intern-pharmacist' && isAustralia">
          <!-- <i class="locumate_icons el-icon-pie-chart"></i> -->
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 2V5" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 2V5" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
              stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M16 3.5C19.33 3.68 21 4.95 21 9.65V15.83C21 19.95 20 22.01 15 22.01H9C4 22.01 3 19.95 3 15.83V9.65C3 4.95 4.67 3.69 8 3.5H16Z"
              stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M20.75 17.6H3.25" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
              stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M12 8.25C10.77 8.25 9.73 8.92 9.73 10.22C9.73 10.84 10.02 11.31 10.46 11.61C9.85 11.97 9.5 12.55 9.5 13.23C9.5 14.47 10.45 15.24 12 15.24C13.54 15.24 14.5 14.47 14.5 13.23C14.5 12.55 14.15 11.96 13.53 11.61C13.98 11.3 14.26 10.84 14.26 10.22C14.26 8.92 13.23 8.25 12 8.25ZM12 11.09C11.48 11.09 11.1 10.78 11.1 10.29C11.1 9.79 11.48 9.5 12 9.5C12.52 9.5 12.9 9.79 12.9 10.29C12.9 10.78 12.52 11.09 12 11.09ZM12 14C11.34 14 10.86 13.67 10.86 13.07C10.86 12.47 11.34 12.15 12 12.15C12.66 12.15 13.14 12.48 13.14 13.07C13.14 13.67 12.66 14 12 14Z"
              fill="rgb(var(--locumate-primary-color))" />
          </svg>




          <div class="text_wrapper">
            <div class="main_text">Registration Year</div>
          </div>
        </el-button>
        <el-button type="transparent" class="menu_item" @click="openPasswordDialog()">
          <!-- <i class="locumate_icons el-icon-pie-chart"></i> -->
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 2V5" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 2V5" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
              stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M16 3.5C19.33 3.68 21 4.95 21 9.65V15.83C21 19.95 20 22.01 15 22.01H9C4 22.01 3 19.95 3 15.83V9.65C3 4.95 4.67 3.69 8 3.5H16Z"
              stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M20.75 17.6H3.25" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
              stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M12 8.25C10.77 8.25 9.73 8.92 9.73 10.22C9.73 10.84 10.02 11.31 10.46 11.61C9.85 11.97 9.5 12.55 9.5 13.23C9.5 14.47 10.45 15.24 12 15.24C13.54 15.24 14.5 14.47 14.5 13.23C14.5 12.55 14.15 11.96 13.53 11.61C13.98 11.3 14.26 10.84 14.26 10.22C14.26 8.92 13.23 8.25 12 8.25ZM12 11.09C11.48 11.09 11.1 10.78 11.1 10.29C11.1 9.79 11.48 9.5 12 9.5C12.52 9.5 12.9 9.79 12.9 10.29C12.9 10.78 12.52 11.09 12 11.09ZM12 14C11.34 14 10.86 13.67 10.86 13.07C10.86 12.47 11.34 12.15 12 12.15C12.66 12.15 13.14 12.48 13.14 13.07C13.14 13.67 12.66 14 12 14Z"
              fill="rgb(var(--locumate-primary-color))" />
          </svg>




          <div class="text_wrapper">
            <div class="main_text">Password Change</div>
          </div>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  onMounted,
  inject,
  defineAsyncComponent,
  nextTick,
  computed
} from "vue";

// import { addIcons } from "ionicons";
// import { arrowBackOutline } from "ionicons/icons";
// import moment from "moment";

// addIcons({
//   "arrow-back-outline": arrowBackOutline,
// });
import {
  IonToolbar,
  IonButton,
  IonButtons,
  // IonIcon,
  IonTitle,
} from "@ionic/vue";

import { useStore } from "vuex";
import {
  useRouter,
  onBeforeRouteLeave,
} from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";

import { VueGoogleSuburbAutocomplete } from "@/components/components";

import { ElMessageBox } from "@/components/Vendor/Element";

import { isAustraliaRegion, isUSRegion } from '@/helpers/region/regionHelper.js';


const VueTelInput = defineAsyncComponent(() =>
  import("@/components/Vendor/vue-tel-input/components/vue-tel-input.vue")
);

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    // IonIcon,
    IonTitle,

    VueGoogleSuburbAutocomplete,

    VueTelInput,
  },
  setup() {

    const $store = useStore();
    const $router = useRouter();
    const setPageClassGlobal = inject(["setPageClassGlobal"]);
    const googleMaps = inject(["googleMaps"]);
    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;
    const email = userData.email;
    const backPage = $store.getters.getLastPage;
    const isAustralia = isAustraliaRegion();
    const isUS = isUSRegion();

    const countryArray = computed(() => {
            const region = process.env.VUE_APP_REGION;
            if (region === 'US') return ['us'];
            if (region === 'AU') return ['au'];
            return []; // Default or empty if region is not recognized
        });

    const formsDataArray = {
      userForm: {
        firstName: {
          value: userData?.firstName || "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "firstName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        lastName: {
          value: userData?.lastName || "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "lastName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        address: {
          value: {
            text: userData.address.fullAddress ? userData.address.fullAddress : '',
            temp: userData.address.fullAddress ? userData.address.fullAddress : ''
          },
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "seekerAddress",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },

        mobileNumber: {
          ref: {},
          value: userData.mobileNumber ? userData.mobileNumber : "",
          valueFormatted: userData.mobileNumber ? userData.mobileNumber : "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "mobileNumber",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
          errors: null,
        },
        email: {
          value: email ? email : "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "email",
                  callback,
                  setFormValidation
                );
              },
              trigger: ["blur", "enter"],
            },
          ],
        },
      },
    };


    const links = {
      changeJobSeekerAdditional: () => {
        $router.push({
          name: "additional_profile_job_seeker",
        });
      },
      softwareExperience: () => {
        $router.push({
          name: "profile_job_seeker_software_experience",
        });
      },
      pharmacyExperience: () => {
        $router.push({
          name: "profile_job_seeker_pharmacy_certification",
        });
      },
      universities: () => {
        $router.push({
          name: "profile_job_seeker_universitites",
        });
      },
      registration: () => {
        $router.push({
          name: "profile_job_seeker_registration",
        });
      },
    };
    const onPhoneInput = (value, phoneObject) => {
      if (!value.target) {
        formsData.userForm.mobileNumber.ref.phoneObject = phoneObject;
      }
      formsData.userForm.mobileNumber.valueFormatted = value.target
        ? value.target.value
        : value;
      formsData.userForm.mobileNumber.value =
        formsData.userForm.mobileNumber.ref.phoneObject.number || null;

      checkFormValidation("userForm", false, "mobileNumber");
      checkFormValidation("userForm", true);

    };

    // Define a computed property to determine the label dynamically
    const formLabel = 'Given Name';

    const setAddress = () => {
      if (
        formsData.userForm.address.value.text !=
        formsData.userForm.address.value.temp
      ) {
        formsData.userForm.address.value.text = null;
      }
      checkFormValidation("userForm", true, "address");
      checkFormValidation("userForm", true);

    };

    const fixValidation = () => {
      // Forcing to check form validation as continue button was not working
      checkFormValidation('userForm', true)
    }

    const setAddressData = async (addressData, placeResultData) => {
      try {
        formsData.userForm.address.value.lat = addressData.latitude.toString();
        formsData.userForm.address.value.lng = addressData.longitude.toString();
        formsData.userForm.address.value.subpremise = (addressData.subpremise ? addressData.subpremise : "")
        formsData.userForm.address.value.street = "";

        formsData.userForm.address.value.state =
          addressData.administrative_area_level_1
            ? addressData.administrative_area_level_1
            : "";
        formsData.userForm.address.value.suburb = addressData.locality
          ? addressData.locality
          : "";
        formsData.userForm.address.value.country = addressData.country
          ? addressData.country
          : "";
        formsData.userForm.address.value.postcode = addressData.postal_code
          ? addressData.postal_code
          : "";
        formsData.userForm.address.value.city = placeResultData.vicinity ? placeResultData.vicinity : "";

        console.log("placeResultData", placeResultData.formatted_address);
        formsData.userForm.address.value.text =
          placeResultData.formatted_address;
        formsData.userForm.address.value.temp =
          placeResultData.formatted_address;
        formsData.userForm.address.ref.update(
          formsData.userForm.address.value.text
        );
        const timezone = await googleMaps.getTimeZone(
          formsData.userForm.address.value.lat +
          "," +
          formsData.userForm.address.value.lng
        );
        formsData.userForm.address.value.timezone = timezone.timeZoneId;
      } catch (error) {
        console.log(error);
      }
      checkFormValidation("userForm", true);
    };

    const goBack = () => {
      if (backPage === '/job-seeker/index') {
        $router.push({
          name: "job_seeker_index",
        });
      }else if(backPage === '/job-seeker/profile/setting'){
        $router.push({
          name: "profile_job_seeker_setting",
        });
      }else if(backPage === '/job-seeker/previous-applications'){
        $router.push({
          name: "job_seeker_previous_applications",
        });
      } else {
        $router.push({
          name: "job_seeker_profile",
        });
      }

    };

    const getFormData = (formName) => {
      const result = Object.fromEntries(
        Object.entries(formsData[formName])
          .map(([k, v]) => [k, v?.value])
          .filter(([k, v]) => v !== undefined) // eslint-disable-line no-unused-vars
      );
      return result;
    };


    const save = (formName) => {
      console.log('formName', formName)
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          return (async () => {
            try {

              if (
                (formsData[formName].firstName &&
                  formsData[formName].firstName.fieldChanged) ||
                (formsData[formName].lastName &&
                  formsData[formName].lastName.fieldChanged)
              ) {
                await ElMessageBox.confirm(
                  "Are you sure you want to change this?",
                  {
                    distinguishCancelAndClose: true,
                    showConfirmButton: !formsData[formName].disabled,
                    confirmButtonText: "Save Changes",
                    cancelButtonText: "Cancel",
                    confirmButtonClass: "el-button--green",
                    cancelButtonClass: "el-button--grey",
                    showClose: formsData[formName].disabled,
                  }
                );
                $store.dispatch("IDENTIFY_USER", {
                  name: formsData[formName].firstName.value,
                });
                console.log('IDENTIFY SUCCESFULLY')

              }
              const data = getFormData(formName);
              const mobileNumber = data.mobileNumber;
              const email = data.email;
              delete data.mobileNumber;
              delete data.email;

              let requests = [];
              requests.push($store.dispatch("SAVE_USER_DATA", data));
              let mobileNumberChanged = false;
              let emailChanged = false;
              console.log('FORM DATA:', formsData[formName])
              if (
                formsData[formName].mobileNumber &&
                formsData[formName].mobileNumber.fieldChanged
              ) {
                mobileNumberChanged = true;
                requests.push(
                  $store.dispatch("UPDATE_USER_PHONE", {
                    phone: mobileNumber,
                  })
                );
              }

              if (
                formsData[formName].email &&
                formsData[formName].email.fieldChanged
              ) {
                emailChanged = true;
                requests.push($store.dispatch("IDENTIFY_USER", { email }));
                requests.push(
                  $store.dispatch("UPDATE_USER_EMAIL", {
                    email: email,
                  })
                );
              }

              await Promise.all(requests);

              if (mobileNumberChanged) {
                $store.dispatch("setVerifyPageData", {
                  mobileNumber: mobileNumber,
                });
              }

              if (emailChanged) {
                $store.dispatch("setVerifyPageData", {
                  email: email,
                });
              }

              copyFormResetValue("userForm", true);
              goBack();
            } catch (errors) {
              $store.dispatch("clearVerifyPageData", {
                mobileNumber: null,
                email: null,
              });
              for (let key in errors) {
                setFieldError(formName, key, errors[key]);
                // }
                // setFieldError('userForm', 'password', error.message);
              }
              checkFormValidation(formName, true);
              nextTick(() => {
                setFormValidation(formName, "mobileNumber", true);
              });
            }
          })();
        } else {
          setFormValidation(formName, false, false);
          console.log("error submit!!");
          return false;
        }
      });
    };

    
    const openPasswordDialog = () => {
       $store.dispatch("PASSWORD_RESET");
        $router.push({
          name: "password_change",
        });
      
      
    };

    onBeforeRouteLeave((to, from, next) => {
      (async () => {
        try {
          let leave = await checkFormChanged("userForm", true);
          if (leave == "save") {
            await save("userForm");
          } else if (!leave) {
            next(false);
          } else {
            next();
          }
        } catch (error) {
          next(false);
          console.log(error);
        }
      })();
    });

    onMounted(() => {
      console.log("hello dolly", formsData.userForm.address.value.text)
      setPageClassGlobal("global_basic_profile_edit_job_seeker");
      setFormRefs();

      if(formsData.userForm.address.value.text !== 'undefined'){
        formsData.userForm.address.ref.update(
        formsData.userForm.address.value.text
      );
      }
     


      checkFormValidation("userForm", true);

    });

    const {
      ["onFormMaskAccept"]: onFormMaskAccept,
      checkFormValidation,
      setFormValidation,
      copyFormResetValue,
      checkFormChanged,
      setFieldError,
      getFormValues, // eslint-disable-line no-unused-vars
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      formsData,
      onFormMaskAccept,
      checkFormValidation,
      goBack,
      save,
      userData,
      userRole,
      setAddressData,
      setAddress,
      onPhoneInput,
      formLabel,
      fixValidation,
      links,
      backPage,
      countryArray,
      isAustralia,
      isUS,
      openPasswordDialog
    };
  },
};
</script>